import React from 'react';
import { Tooltip } from 'react-tooltip';
import { getGroupIcon } from './groupIcons';

// Desktop: icon only, the group name shows in a tooltip on hover.
// Mobile (< md): icon with the name under it, no tooltip (see .group-icon-* in App.css).
const GroupHeader = (props) => {

    return (
        <div className='w-100 my-3 d-flex flex-row align-items-start justify-content-center flex-wrap scroll-target group-icons-row'
            ref={ props.groupsRef }>
            {
                props.groups ?
                props.groups.map(group => {
                    const isActive = group.id === props.activeGroup.id
                    return (
                        <button key = {group.id}
                            type = 'button'
                            className = {isActive ? 'group-icon-btn active' : 'group-icon-btn'}
                            aria-label = {group.title}
                            aria-pressed = {isActive}
                            data-tooltip-id = 'group-tooltip'
                            data-tooltip-content = {group.title}
                            onClick = {()=>{
                                props.onGroupClick(group)
                            }}
                            >
                            <img src = {getGroupIcon(group)} alt = '' className = 'group-icon-img' draggable = {false}/>
                            <span className = 'group-icon-label'>{group.title}</span>
                        </button>
                    )
                }) : ''
            }
            <Tooltip id = 'group-tooltip' className = 'bg-info text-primary group-tooltip' style = {{zIndex:'1000'}}/>
        </div>
    );
};

export default GroupHeader;
